module.exports = {
    env: 'local',

    // apiUrl: '//dental-api.sierratech.app/v1/',
    apiUrl: '//dental-api.medix.ph/v1/',
    // apiUrl: '//localhost:8000/v1/',

    defaultTenant: 'dental',
    // defaultTenant: 'drarvinpvillegasdentalclinic',
    // defaultTenant: 'novodental',
    // defaultTenant: 'abellada-dental',
    // defaultTenant: 'paylipdental',
    // defaultTenant: 'lelis-dental',
    // defaultTenant: 'novenario',
    // defaultTenant: 'thesassydentist',
    // defaultTenant: 'thedentalstudio',

    staticFiles: '//dental-api.medix.ph/v1/' + 'dental/galleries/local/'
};



/*****************
 ** WEBPACK FOOTER
 ** ./config.js
 ** module id = 4
 ** module chunks = 0
 **/